import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../utils/content.json';

const questionForRelationship = relationship => {
  if (relationship === 'CUSTODIAN_FILING_FOR_CHILD_UNDER_18') {
    return {
      title: content['financial-info-home-ownership-question-custodian'],
      hint: content['financial-info-home-ownership-hint-custodian'],
    };
  }
  if (relationship === 'SURVIVING_CHILD') {
    return {
      title: content['financial-info-home-ownership-question-child'],
      hint: content['financial-info-home-ownership-hint-default'],
    };
  }
  return {
    title: content['financial-info-home-ownership-question-default'],
    hint: content['financial-info-home-ownership-hint-default'],
  };
};

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['financial-info-home-ownership-title']),
    homeOwnership: yesNoUI({
      title: content['financial-info-home-ownership-question-default'],
      hint: content['financial-info-home-ownership-hint-default'],
      updateUiSchema: formData => {
        const { title, hint } = questionForRelationship(
          formData?.claimantRelationship,
        );
        return {
          'ui:title': title,
          'ui:options': { hint },
        };
      },
    }),
  },
  schema: {
    type: 'object',
    required: ['homeOwnership'],
    properties: {
      homeOwnership: yesNoSchema,
    },
  },
};
